import type { PaletteMode, Theme } from '@mui/material';
import { responsiveFontSizes } from '@mui/material';
import { createTheme } from '@mui/material/styles';

// ✅ Theme created once at module level — never recreated on re-renders
const theme: Theme = responsiveFontSizes(
  createTheme({
    palette: {
      mode: 'light' as PaletteMode,
      background: {
        default: 'rgb(255, 255, 255)',
        paper: 'rgb(255, 255, 255)',
      },
      text: {
        primary: 'rgb(68, 68, 68)',
        secondary: 'rgb(153, 153, 153)',
      },
      primary: {
        main: 'rgb(33, 62, 153)',
        contrastText: 'rgb(255, 255, 255)',
      },
      secondary: {
        main: 'rgb(64, 64, 64)',
        contrastText: 'rgb(255, 255, 255)',
      },
      success: {
        main: '#1da94a',
        contrastText: '#999',
      },
      divider: 'rgba(145, 158, 171, 0.24)',
    },
    typography: {
      fontFamily: "'Poppins', sans-serif",
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: `
          html, body {
            font-family: 'Poppins', sans-serif !important;
          }
          .MuiDialog-root *,
          .MuiPopover-root *,
          .MuiMenu-root *,
          .MuiTooltip-popper *,
          .MuiAutocomplete-popper * {
            font-family: 'Poppins', sans-serif !important;
          }
        `,
      },
      // ✅ Disable ripple globally — removes ripple JS execution on every click
      MuiButtonBase: {
        defaultProps: {
          disableRipple: true,
        },
      },
    },
  })
);

// ✅ Export both named and default for backwards compatibility
export { theme };
export default function getTheme(): Theme {
  return theme;
}
